import { render, staticRenderFns } from "./facebook-audience-source-card.vue?vue&type=template&id=f2d2a35c"
import script from "./facebook-audience-source-card.vue?vue&type=script&lang=js"
export * from "./facebook-audience-source-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports